if (window.location) {
    const location = window.location
    if (location.pathname === '/') {
        if (window.location.host === 'shop-dev.hachettebookgroup.com') {
            window.location = "https://hbg-preprod.go-vip.co/"
        }
    }
    if (location.host === 'shop.hachettebookgroup.com' && 
        !location.pathname.includes('/checkout') &&
        !location.pathname.startsWith('/products/')) 
        {
        window.location = "https://www.hachettebookgroup.com/"
    }
}